import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledSpecsWrapper = styled.div`
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  padding: 10px 31px 22px;
  gap: 24px;

  @media (min-width: 767px) {
    flex-direction: row;
    align-items: flex-start;
    padding: 48px 28px;
    gap: 30px;
  }
`;

export const StyledSpecs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${Breakpoints.b560}px) {
    width: 50%;
    gap: 32px;
  }
`;

export const StyledSpec = styled.div`
  display: flex;
  font-family: 'vw-text';
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  gap: 5px;
  width: 100%;
  flex-direction: column;
`;

export const StyledSpecHeading = styled.div`
  font-weight: bold;
  text-align: left;

  @media (min-width: ${Breakpoints.b960}px) {
    &.spec-color {
      width: max-content;
    }
  }

  @media (min-width: ${Breakpoints.b960}px) {
    width: 100%;
  }
`;

export const StyledSpecText = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #3c484d;
  font-weight: 400;

  @media (min-width: ${Breakpoints.b960}px) {
    width: 100%;
  }
`;

export const StyledColorWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const StyledColor = styled.div`
  width: 100%;
  @media (min-width: ${Breakpoints.b960}px) {
    width: 50%;
  }
`;

interface ColorDotProps {
  colorCode?: string;
}

export const StyledColorDot = styled.div<ColorDotProps>`
  width: 16px;
  height: 16px;
  ${(props: ColorDotProps) =>
    props.colorCode ? `border: 1px solid ${props.colorCode}` : ''};
  border-radius: 100%;
  background-color: ${(props: ColorDotProps) =>
    props.colorCode ? props.colorCode : ''};
`;

export const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction column;
  gap: 5px;
  width: 100%;
`;
